import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Nav, Tab } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import * as alert from '../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../redux/confirmModalRedux';
import SupplementaryDocumentsTab from './aiKnowledgeBase/SupplementaryDocumentsTab';
import SystemDocumentsTab from './aiKnowledgeBase/SystemDocumentsTab';
import { IoFileTrayFullOutline, IoDocumentTextOutline, IoSettingsOutline, IoDocumentsOutline } from "react-icons/io5";
import { LuFolders, LuFolderPlus, LuSettings } from "react-icons/lu";

const getKnowledgeBaseTab = (search) => {
  const tab = new URLSearchParams(search).get('tab');
  return tab === 'supplementary' ? 'supplementary' : 'system';
};

const AiDocumentManagerPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => getKnowledgeBaseTab(location.search));

  useEffect(() => {
    setActiveTab(getKnowledgeBaseTab(location.search));
  }, [location.search]);

  useEffect(() => {
    const currentLocation = history.location;
    const params = new URLSearchParams(currentLocation.search);
    if (params.get('tab') === activeTab) return;

    params.set('tab', activeTab);
    history.replace({ ...currentLocation, search: `?${params.toString()}` });
  }, [activeTab, history]);

  const changeTab = (tab) => {
    const nextTab = tab || 'system';
    if (nextTab === activeTab) return;

    const currentLocation = history.location;
    const params = new URLSearchParams(currentLocation.search);
    params.set('tab', nextTab);
    history.push({ ...currentLocation, search: `?${params.toString()}` });
    setActiveTab(nextTab);
  };

  return (
    <div className='row aes-admin-listing-page aes-admin-listing-page--ai-knowledge'>
      <div className='col-lg-12 col-xxl-12'>
        <div className='card card-custom card-stretch gutter-b'>
          <Tab.Container activeKey={activeTab} onSelect={changeTab} mountOnEnter>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label font-weight-bolder text-dark'>AI Knowledge Base</span>
                {/* <span className='text-muted mt-3 font-weight-bold fz-xs'>Manage the documents available to the AES Assistant</span> */}
              </h3>
              <div className='card-toolbar'>
                <Nav as='ul' className='nav nav-tabs nav-tabs-line nav-bold border-0'>
                  <Nav.Item as='li'>
                    <Nav.Link eventKey='system' className='d-flex align-items-center py-2' style={{ fontSize: '16px', gap: '5px' }}>
                      {/* <LuFolders size={20} /> */}
                      System
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li'>
                    <Nav.Link eventKey='supplementary' className='d-flex align-items-center py-2' style={{ fontSize: '16px', gap: '5px' }}>
                      {/* <LuFolderPlus size={20} /> */}
                      Supplementary
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li'>
                    <Nav.Link as={Link} to='/management/settings?tab=ai' className='d-flex align-items-center py-2' style={{ fontSize: '16px', gap: '5px' }}>
                      <LuSettings size={20} />
                      Settings
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </div>

            <Tab.Content>
              <Tab.Pane eventKey='system'>
                <SystemDocumentsTab {...props} />
              </Tab.Pane>
              <Tab.Pane eventKey='supplementary'>
                <SupplementaryDocumentsTab {...props} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { ...alert.actions, ...confirmModal.actions })(AiDocumentManagerPage);
